import React, { useEffect, useState } from 'react';
import {
    Typography,
    Button,
    Divider,
    CardContent,
    Box,
    CardHeader,
    Card,
    Link,
    CircularProgress
} from '@mui/material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import styles, { MigratedAssetsQrcolumns, boxSX } from './Styles';
import { post } from "../../services";
import Select from "react-select";
import Cookies from "js-cookie";
import SSPCommonModal from '../../CommonComponents/SSPCommonModal/SSPCommonModal';
import { SSPCommonButton } from '../../CommonComponents';
import SearchIcon from '@mui/icons-material/Search';

const ThirdTab = ({ rowData }) => {
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const [locationCode, setLocationCode] = useState('');
    const [locationCodeOptions, setLocationCodeOptions] = useState([]);
    const [locationKey, setlocationKey] = useState(0);
    const [loading, setLoading] = useState(false);

    const id = Cookies.get("ssp_domain_id");
    const base = "https://";

    useEffect(() => {
        getLocationCodeList();
    }, [])

    const handleDownloadFile = async (path) => {
        setLoading(true)
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_generated_tags",
            {
                file_name: path,
                domain_id: id,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.url);
        } else {
            setLoading(false)
            setmessage(response?.message);
            setmodalOpener(true);
        }

    };

    const downloadAssetQrFile = async () => {
        if (locationCode === "") {
            setmessage("Please select Location Code");
            setmodalOpener(true);
            return;
        }
        else {
            setLoading(true)
            let response = await post(
                base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_qr_zip",
                {
                    loc: locationCode,
                    domain_id: id,
                    source: "SSP"
                },
                true,
                false
            );
            if (response?.status === "success") {
                setLoading(false)
                window.open(response?.url);
                setLocationCode("");
                setlocationKey(prev => prev + 1);
            } else {
                setLoading(false)
                setmessage(response?.message);
                setmodalOpener(true);
            }

        }
    }

    const handleDownloadPendingLocations = async () => {
        setLoading(true)
        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/download_pending_locations",
            {
                domain_id: id,
                source: "SSP"
            },
            true,
            false
        );
        if (response?.status === "success") {
            setLoading(false)
            window.open(response?.url);
        } else {
            setLoading(false)

            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
        }

    }

    const getLocationCodeList = async () => {

        let response = await post(
            base + "bjkhbsrllhuogrxobvufau4rxy0qvvxu.lambda-url.ap-south-1.on.aws/get_all_locations",
            { "domain_id": id, source: "SSP" },
            true,
            false
        );
        if (response?.status === "success") {
            setLocationCodeOptions(
                response?.data?.map((item) => ({
                    label: item?.loc + " - " + item?.loc_name,
                    value: item?.loc?.toString(),
                }))
            );
        } else {
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    };

    return (
        <div style={styles.tabContent}>
            <div style={styles.locContainer}>
                <Typography>Location Code</Typography>
                <Box sx={{ position: "relative", }}>
                    <SearchIcon
                        sx={styles.searchIconStyle}
                    />
                    <Select
                        options={locationCodeOptions}
                        key={locationKey}
                        value={locationCodeOptions.find((opt) => opt.value === locationCode)}
                        onChange={(selectedOption) => {
                            setLocationCode(selectedOption?.value || "")
                        }}

                        isSearchable
                        placeholder="Choose a location"
                        isClearable
                        styles={{
                            container: (base) => ({ ...base, width: 250 }),
                            control: (base, state) => ({
                                ...base,
                                paddingLeft: "30px",
                                minHeight: "40px",
                                borderColor: "black",
                                backgroundColor: '#ffffff',
                                boxShadow: state.isFocused ? "0 0 0 1px black" : "none",
                                "&:hover": {
                                    borderColor: "black",
                                },
                                opacity: state.isDisabled ? 0.4 : 1,
                                cursor: state.isDisabled ? "not-allowed" : "default",
                            }),
                            input: (base) => ({
                                ...base,
                                margin: 0,
                            }),
                        }}
                    />
                </Box>

                <SSPCommonButton
                    btnText={"Download File"}
                    btnFunction={() => downloadAssetQrFile()}
                />

            </div>
            <Box p={1} sx={styles.buttonBox} >
                <Link
                    component={"button"}
                    color={"#0160F1"}
                    sx={boxSX}
                    onClick={handleDownloadPendingLocations}
                >
                    {"Download Pending Locations"}
                </Link>

            </Box>
            {loading && (
                <div style={styles.loaderOverlay}>
                    <CircularProgress />
                </div>
            )}

            <Card sx={styles.cardStyle} >
                <CardHeader
                    p={2}
                    sx={styles.cardHeader}
                    title={"Previous Downloads"}
                    titleTypographyProps={{
                        sx: {
                            fontSize: "16px",
                            fontWeight: "600",
                            lineHeight: "16px",
                            color: "#0160F1",
                        },
                    }}
                    action={
                        <>
                            <Button onClick={() => window.location.reload()}>
                                Refresh Page
                            </Button>
                        </>
                    }
                />
                <Divider />
                <CardContent sx={{ backgroundColor: "#FFFFFF", borderBottomRightRadius: "5px", borderBottomLeftRadius: "5px" }}>
                    <Box sx={{ height: 700, width: "100%" }}>

                        <DataGrid
                            disableColumnMenu={true}
                            rowHeight={80}
                            showCellRightBorder={true}
                            sx={{
                                ".MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: "bold !important",
                                },
                                ".MuiDataGrid-cell": {
                                    fontSize: "0.8rem",
                                },
                                overflowX: "scroll",
                            }}
                            rows={rowData}
                            columns={MigratedAssetsQrcolumns(handleDownloadFile)}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10,
                                    },
                                },
                            }}
                            headerClassName="header-center"
                            rowsPerPageOptions={[10]}
                            pageSize={10}
                            getRowId={(row) => row.id}
                            components={{
                                Toolbar: GridToolbar,
                            }}
                            componentsProps={{
                                Toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                        />
                    </Box>
                </CardContent>
                {modalOpener && (
                    <SSPCommonModal
                        open={modalOpener}
                        handleOpenClose={setmodalOpener}
                        message={message}
                    />
                )}
            </Card>
        </div>
    );
};

export default ThirdTab;
